import { BetSettlementType } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betSettlementTypeDictionary = createSimpleDictionary([
    { id: BetSettlementType.New, name: 'dictionaries.betSettlementType.new' },
    { id: BetSettlementType.Update, name: 'dictionaries.betSettlementType.update' },
]);
